import AllBlogs from "../../../../src/components/blogs/all-blogs";
import * as React from 'react';
export default {
  AllBlogs,
  React
};